export const appendGenesysIdInput = (form) => {
    const conversationId = sessionStorage.getItem('conversation_id')
    if (conversationId) {
        const genesysConversationIdInput = document.createElement('input')
        genesysConversationIdInput.name = 'conversation_id'
        genesysConversationIdInput.type = 'hidden'
        genesysConversationIdInput.value = conversationId
        form.appendChild(genesysConversationIdInput) 
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/utils/addGenesysId.js